import { render, staticRenderFns } from "./AutomationsMain.vue?vue&type=template&id=1d8e136b&scoped=true&"
import script from "./AutomationsMain.vue?vue&type=script&lang=js&"
export * from "./AutomationsMain.vue?vue&type=script&lang=js&"
import style0 from "./AutomationsMain.vue?vue&type=style&index=0&id=1d8e136b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8e136b",
  null
  
)

export default component.exports